import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { CleaningListComponent } from "./CleaningListComponent";
import * as cleaningActionsCreators from "../actions";
import { getUsers } from "../../users/actions";
import { getRooms } from "../../rooms/actions";
import { loadCleaning, loadFresh } from "../schedule/actions";
import { isAdmin } from "../../users/selectors";
import { translate } from "react-i18next";
import { getMessageVisibility } from "../../messages/selectors";
import { toggleMessage } from "../../messages/actions";
class CleaningListContainer extends Component {
  componentDidMount() {
    if (this.props.users.length === 0) {
      this.props.getUsers();
    }
    if (this.props.cleaningList.length === 0) {
      this.props.getCleaningList();
    }
    if (this.props.rooms.length === 0) {
      this.props.getRooms();
    }
  }

  render() {
    return <CleaningListComponent {...this.props} />;
  }
}

const mapStateToProps = state => {
  return {
    cleaningList: state.cleaning.data,
    users: state.users.data,
    rooms: state.rooms.data,
    infoCleaningMessageVisible: getMessageVisibility("infoCleaningMessage")(
      state
    ),
    isAdmin: isAdmin(state)
  };
};
const mapDispatchToProps = dispatch => ({
  ...bindActionCreators(
    {
      ...cleaningActionsCreators,
      getRooms,
      getUsers,
      loadFresh,
      loadCleaning,
      toggleMessage
    },
    dispatch
  )
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(translate("translations")(CleaningListContainer));



// WEBPACK FOOTER //
// ./src/cleaning/CleaningList/index.js